// src/db/firebase/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import firebaseConfig from './config';

const app = initializeApp(firebaseConfig);

const firebase = {
  app,
  db: getFirestore(app),
  rt: getDatabase(app),
  storage: getStorage(app),
  auth: getAuth(app)
};

export default firebase;